export const HOME_URL = process.env.REACT_APP_HOME_URL;
export const HOME_SSR_URL = process.env.REACT_APP_SSR_API_URL;
